import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const SimpleUnits = (props) => {

    const { simpleProduct, setSimpleProduct, productUnits, setProductUnits } = props;

    const { api, userData, settingData, categoryData, vatGroupData, selectedCompany, accountData,
        productData, refData, branchData, projectData, currencyData, formLanguages } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    // Add VarientRow
    const handleAddRow = () => {
        setProductUnits([...productUnits, { name: '', quantity: 0, price: 0, raiseBy: 0, productId: idRow?.id }]);
    };

    // Delete VarientRow
    const handleDeleteRow = (event) => {
        event.preventDefault()
        if (productUnits.length > 0) {
            const updatedRows = productUnits.slice(0, -1);
            setProductUnits(updatedRows);
        } else {
            toast.error('you need at least one variant')
        }
    };


    // Change Unit Array
    const handleUnitChange = (index, field, value) => {
        const updatedUnits = [...productUnits];

        updatedUnits[index] = { ...updatedUnits[index], [field]: value };

        if (field == 'raiseBy') {
            updatedUnits[index].price = (simpleProduct.cost * (1 + updatedUnits[index].raiseBy / 100)) * updatedUnits[index].quantity;
        }
        else if (field == 'quantity') {
            updatedUnits[index].price = (simpleProduct.cost * (1 + updatedUnits[index].raiseBy / 100)) * updatedUnits[index].quantity;
        }
        else if (field == 'price') {
            updatedUnits[index].raiseBy = ((((updatedUnits[index].price / updatedUnits[index].quantity) / simpleProduct.cost) - 1) * 100).toFixed(2);
        }

        setProductUnits(updatedUnits);
    }



    return (

        <div>

            {productUnits.map((row, index) => (
                <div key={index}>
                    {/* Render the labels only for the first row */}
                    {index === 0 && (
                        <Row className="mb-3">
                            <Form.Group as={Col}>
                                <Form.Label>Unit</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>{formLanguages.Quantity}</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>{formLanguages.RaiseBy}</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>{formLanguages.Price}</Form.Label>
                            </Form.Group>
                        </Row>
                    )}

                    <Row className="mb-3" style={{ marginTop: '-20px' }}>

                        <Form.Group as={Col}>
                            <Form.Control type="text" name="name"
                                onChange={(e) => handleUnitChange(index, 'name', e.target.value)}
                                value={row.name}
                                required />
                        </Form.Group>

                        <Form.Group as={Col}>
                            <Form.Control type="number" step="any" name="quantity"
                                onChange={(e) => handleUnitChange(index, 'quantity', e.target.value)}
                                value={row.quantity}
                                required />
                        </Form.Group>

                        <Form.Group as={Col}>
                            <Form.Control type="number" step="any" name="raiseBy"
                                onChange={(e) => handleUnitChange(index, 'raiseBy', e.target.value)}
                                value={row.raiseBy}
                                required />
                        </Form.Group>


                        <Form.Group as={Col}>
                            <Form.Control type="number" step="any" name="price"
                                onChange={(e) => handleUnitChange(index, 'price', e.target.value)}
                                value={row.price}
                                required />
                        </Form.Group>



                    </Row>

                    <Row key={index + 100} className="mb-3">

                    </Row>
                </div>
            ))}

            <Form.Group
                as={Col}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={handleAddRow} />
                <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e)} />
            </Form.Group>
        </div>

    )
}


export default SimpleUnits; 